module.exports = __webpack_public_path__ + "static/media/banner-home.7ed94f40.png";